module.exports = __webpack_public_path__ + "static/media/powered_by.718ea01c.jpeg";